import {gql} from '@apollo/client'
import {FlowStatus} from './types'

const PROCEDURE_FLOW_STATUS_FRAGMENT = gql`
  fragment ProcedureFlowStatusFragment on ProcedureStatus {
    flowStatus: procedureTmpDatum(type: $typeForFlowStatus, name: "flow_status") {
      id
      type
      name
      data
    }
  }
`

export const PROCEDURE_FLOW_STATUS = gql`
  query procedureFlowStatus($procedureStatusId: ID!, $typeForFlowStatus: ProcedureTmpType!) {
    client {
      id
      procedureStatus(procedureStatusId: $procedureStatusId) {
        id
        procedureType
        status
        employee {
          id
          user {
            id
          }
        }
        procedureComments {
          id
          comment
          type
          user {
            id
            employee {
              id
              firstName
              lastName
              displayFirstName
              displayLastName
            }
          }
          createdAt
          updatedAt
        }
        ...ProcedureFlowStatusFragment
      }
    }
  }
  ${PROCEDURE_FLOW_STATUS_FRAGMENT}
`

export interface ProcedureFlowStatusQueryVariables {
  procedureStatusId: string
  typeForFlowStatus: string
}

export interface ProcedureFlowStatusQueryResult {
  client: {
    id: string
    procedureStatus?: {
      id: string
      procedureType: string
      status: string
      employee: {
        id: string
        user?: {
          id: string
        }
      }
      procedureComments: ProcedureComment[]
      flowStatus?: {
        id: string
        type: string
        name: string
        data: Partial<FlowStatus>
      }
    }
  }
}

export interface ProcedureComment {
  id: string
  comment: string
  type: string
  user: {
    id: string
    employee: {
      id: string
      firstName: string
      lastName: string
      displayFirstName: string
      displayLastName: string
    }
  }
  createdAt: string
  updatedAt: string
}

export const UPDATE_PROCEDURE_FLOW_STATUS = gql`
  mutation updateProcedureFlowStatus($input: UpdateProcedureTmpDatumInput!, $typeForFlowStatus: ProcedureTmpType!) {
    updateProcedureTmpDatum(input: $input) {
      procedureStatus {
        id
        ...ProcedureFlowStatusFragment
      }
    }
  }
  ${PROCEDURE_FLOW_STATUS_FRAGMENT}
`

export const REJECT_PROCEDURE_STATUS = gql`
  mutation rejectProcedureStatus($input: RejectProcedureStatusInput!) {
    rejectProcedureStatus(input: $input) {
      procedureStatus {
        id
      }
    }
  }
`

export interface RejectProcedureStatusQueryVariables {
  input: {
    procedureStatusId: string
    comment: string
  }
}
